import * as React from 'react';
import { useHistory } from 'react-router-dom';

import { Button, Typography } from 'antd';

import { useIsFetching } from '@tanstack/react-query';
import type IProduct from 'interfaces/IProduct';
import { OfferCurrencyAlert } from 'v2/components/Shared/OfferCurrencyAlert';
import { Space } from 'v2/components/Shared/Space';

import { List } from './List';
import { FormContent } from '../../../FormContent';

type OffersProps = {
  product: IProduct;
  loading: boolean;
  hasUnsavedChanges: boolean;
  openConfirmModal: (cancelModalCallback?: undefined | (() => void)) => void;
};

function Offers({ product, loading, hasUnsavedChanges, openConfirmModal }: OffersProps) {
  const history = useHistory();
  const isOffersLoading = useIsFetching({
    queryKey: ['products', product.id, 'offers'],
    exact: true
  });

  function navigateToCreateOffer() {
    history.push(`/producer/product/${product.id}/offers/create`, {
      product
    });
  }

  function handleCreateOffer() {
    if (hasUnsavedChanges) {
      openConfirmModal(navigateToCreateOffer);
      return;
    }

    navigateToCreateOffer();
  }

  return (
    <FormContent
      title='Ofertas'
      loading={loading || isOffersLoading > 0}
      action={
        <Button id='create-offer-button' size='small' onClick={handleCreateOffer} type='primary'>
          Cadastrar nova oferta
        </Button>
      }
    >
      <Typography.Text>
        Cadastre ofertas especiais para seu produto e defina um valor especifico para cada moeda.
      </Typography.Text>
      <Space axis='vertical' size={32} />
      <List product={product} hasUnsavedChanges={hasUnsavedChanges} openConfirmModal={openConfirmModal} />
      <Space axis='vertical' size={16} />
      <OfferCurrencyAlert />
    </FormContent>
  );
}

export { Offers };
